module.exports = __webpack_public_path__ + "img/labor-guide-icon.e8be7d3d.svg";